import request from '../utils/request'

// 获取员工列表（分页+模糊查询）
export function getEmployeeList(data) {
  return request({
    url: '/employee/page',
    method: 'post',
    data
  })
}

// 根据ID获取员工详情
export function getEmployeeById(id) {
  return request({
    url: `/employee/${id}`,
    method: 'get'
  })
}

// 获取全部员工
export function getAllEmployees() {
  return request({
    url: '/employee/all',
    method: 'get'
  })
}

// 根据用户ID获取员工信息
export function getEmployeeByUserId(userId) {
  return request({
    url: `/employee/user/${userId}`,
    method: 'get'
  })
}

// 关联用户（员工-用户 一对一）
export function bindEmployeeUser(data) {
  return request({
    url: '/employee/user',
    method: 'put',
    data
  })
}

// 解除关联用户
export function unbindEmployeeUser(employeeId) {
  return request({
    url: `/employee/user/${employeeId}`,
    method: 'delete'
  })
}

// 创建员工
export function createEmployee(data) {
  return request({
    url: '/employee',
    method: 'post',
    data
  })
}

// 更新员工
export function updateEmployee(data) {
  return request({
    url: '/employee',
    method: 'put',
    data
  })
}

// 删除员工
export function deleteEmployee(id) {
  return request({
    url: `/employee/${id}`,
    method: 'delete'
  })
}